import React, {ReactElement} from "react";
import {DashboardView} from "../../../types";
import {AnswerOptimalityPieChartCard} from "../components/DialogueChoises/AnswerOptimalityPieChartCard";
import { SectionPerformanceCard } from "../components/Generic/SectionPerformanceCard";

export const ActivityRendererOverviewCardMapping: {[key in DashboardView]?: ReactElement} = {
    [DashboardView.EXERCISE_DIALOGUE_CHOICES_COVERAGE]: <AnswerOptimalityPieChartCard/>,
    [DashboardView.EXERCISE_TRANSCRIPT_COVERAGE]: <SectionPerformanceCard type='conversation'/>
}
